import { ca } from '@cian/analytics';

export function trackSubmitClick(query: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'button_search',
    label: query,
    page: {
      extra: {
        source: query !== '' ? 'search_string' : '',
      },
    },
  });
}

export function trackMapSubmitClick(query: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'button_search_on_map',
    label: query,
    page: {
      extra: {
        source: query !== '' ? 'search_string' : '',
      },
    },
  });
}
